/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const TimestampBetween: core.serialization.ObjectSchema<
    serializers.TimestampBetween.Raw,
    Truvity.TimestampBetween
> = core.serialization.object({
    left: core.serialization.date(),
    right: core.serialization.date(),
});

export declare namespace TimestampBetween {
    export interface Raw {
        left: string;
        right: string;
    }
}
